import React from "react";
import { AiOutlineEye, AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";

const VendorRegister = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Vendors</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Vendors</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card mt-4">
                <div className="card-header">
                  <h4 className="card-title">Add New Vendor</h4>
                </div>
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <label>Company Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="companyName"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label>Nature of Business:</label>
                        <select
                          className="form-control"
                          name="natureOfBusiness"
                          required
                        >
                          <option value="">Select</option>
                          <option value="Brand Owner">Brand Owner</option>
                          <option value="Distributor">Distributor</option>
                          <option value="Wholesaler">Wholesaler</option>
                        </select>
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Company Website:</label>
                        <input
                          type="url"
                          className="form-control"
                          name="companyWebsite"
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Registered Address:</label>
                        <textarea
                          className="form-control"
                          name="registeredAddress"
                          required
                        />
                      </div>

                      <div className="col-md-4 mt-3">
                        <label>Pin Code:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="pinCode"
                          required
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <label>City:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          required
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <label>State:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="state"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Product Category:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="productCategory"
                          required
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label>Brand Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="brandName"
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Is Brand Already Selling by Others?</label>
                        <select
                          className="form-control"
                          name="isBrandSoldByOthers"
                          required
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>GST Number:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="gstNumber"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Upload GST Certificate:</label>
                        <input
                          type="file"
                          className="form-control"
                          name="gstCertificate"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>
                          Upload Trademark Certificate (if applicable):
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          name="trademarkCertificate"
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Upload PAN:</label>
                        <input
                          type="file"
                          className="form-control"
                          name="panCard"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Upload Signature:</label>
                        <input
                          type="file"
                          className="form-control"
                          name="signature"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Upload Cancelled Cheque:</label>
                        <input
                          type="file"
                          className="form-control"
                          name="cancelCheque"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Upload Bank Details Document:</label>
                        <input
                          type="file"
                          className="form-control"
                          name="bankDetails"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Seller Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="sellerName"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Seller Mobile Number:</label>
                        <input
                          type="tel"
                          className="form-control"
                          name="sellerMobile"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Point of Contact Person:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactPerson"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Contact Mobile Number:</label>
                        <input
                          type="tel"
                          className="form-control"
                          name="contactMobile"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Email ID:</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Pickup Address with Pin Code:</label>
                        <textarea
                          className="form-control"
                          name="pickupAddress"
                          required
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>How did you hear about Lyftcart?</label>
                        <input
                          type="text"
                          className="form-control"
                          name="referralSource"
                        />
                      </div>

                      <div className="col-12 mt-4 text-end">
                        <button type="submit" className="btn btn-success">
                          Submit Vendor Info
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-4 text-center">
          <div className="container-fluid">© 2025 Vendor Management System</div>
        </footer>
      </div>
    </div>
  );
};

export default VendorRegister;
